import createObserver from '../core/createObserver';

import LazyLoadOrigin from './lazyLoadOrigin';
import LazyImgOrigin from './lazyImgOrigin';
import hoc from './hoc';

const { observer, event } = createObserver();

const createComp = hoc(observer, event);

export const LazyLoad = createComp(LazyLoadOrigin);
export const LazyImg = createComp(LazyImgOrigin);
